import {
  ApiResponse,
  EmailVerificationStatusResponse,
  EmailVerificationResendResponse,
  EmailVerificationOverrideResponse,
  SubscriptionResponse,
  UserId,
} from '@arrived/models';

import { api, publicApi } from './api';
import { unwrapApiResponse } from './utils';

export const postSubscribeToNewPropertyNotifications = async (email: string) => {
  const response = await publicApi.post<ApiResponse<SubscriptionResponse>>(
    '/offerings/notifications/new-properties/subscribe',
    { email }
  );

  return unwrapApiResponse(response.data);
};

export const getEmailVerificationStatus = async (userId: UserId) => {
  const response = await api.get<ApiResponse<EmailVerificationStatusResponse>>(`/users/${userId}/is-email-verified`);

  return unwrapApiResponse(response.data);
};

export const postResendEmailVerification = async (userId: UserId) => {
  const response = await api.post<ApiResponse<EmailVerificationResendResponse>>(
    `/users/${userId}/send-verification-email`
  );

  return unwrapApiResponse(response.data);
};

export const postOverrideEmailVerification = async (userId: UserId, status: boolean) => {
  const response = await api.post<ApiResponse<EmailVerificationOverrideResponse>>(
    `/users/${userId}/override-email-verification`,
    { newValue: status }
  );

  return unwrapApiResponse(response.data);
};
